<span (click)="downloadData('xlsx')"  [class.btn]="selectedPage != 'Trips'" *ngIf="selectedPage != 'Trips'">
    <img src="/assets/icons/report_download_gray.png" alt="download"
    style="width: 96%" />
</span>
<!-- <button type="button" class="btn btn-success" *ngIf="selectedPage == 'Trips'" (click)="downloadData('xlsx')">Download</button> -->


<button type="button" *ngIf="selectedPage == 'Trips'" matTooltip="Excel Download" class="btn btn-success w-100 d-flex align-items-center justify-content-center" (click)="downloadData('xlsx')">
    <i class="bi bi-file-earmark-excel" style="color: #FFF; font-size: 24px; margin-right: 5px;"></i> Excel
  </button>